import { useEffect, useState } from "react";
import "./Hero.css";
import API_ROUTES from "./config/apiConfig";
import { getPublicRequest } from "../api/auth";

function Hero() {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    getPublicRequest(API_ROUTES.GET_BANNERS)
      .then((res) => {
        if (res?.success) {
          setBanners(res.data || []);
        }
      })
      .catch(console.error);
  }, []);

  // Auto slide
  useEffect(() => {
    if (banners.length <= 1) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [banners]);

  if (!banners.length) {
    return (
      <div className="hero">
        <video autoPlay muted loop className="hero-video">
          <source src="/videos/back.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  return (
    <div className="hero">

      {banners.map((banner, i) => (
        <div
          key={banner.id}
          className={`hero-slide ${i === current ? "active" : ""}`}
        >
          {banner.media_type?.toLowerCase() === "video" ? (
            <video
              src={banner.video_url}
              autoPlay
              muted
              loop
              className="hero-video"
            />
          ) : (
            <img
              src={banner.image_url}
              alt={banner.title}
              className="hero-image"
            />
          )}
        </div>
      ))}

      <div className="hero-content">
        <h1>{banners[current]?.title}</h1>
      </div>

    </div>
  );
}

export default Hero;